import dayjs from "dayjs";
import "dayjs/locale/tr";
import localizedFormat from "dayjs/plugin/localizedFormat";
import { Breadcrumb } from "antd";
import { Link } from "react-router-dom";
import { Tooltip } from "antd";
import { t } from "i18next";
import { ReadingStatsI } from "./View";

dayjs.extend(localizedFormat);
dayjs.locale("tr");

interface ArticleHeaderPropsI {
    title: string;
    imgUrl: string;
    slug: string;
    category: string;
    updatedDate: Date;
    createdDate: Date;
    isPinned: boolean;
    wordStats: ReadingStatsI;
    className: string;
}

export const ArticleHeader = ({
    slug,
    title,
    imgUrl,
    category,
    updatedDate,
    createdDate,
    isPinned,
    wordStats,
    className,
}: ArticleHeaderPropsI) => {
    const created = dayjs(createdDate);
    const updated = dayjs(updatedDate);
    return (
        <div
            className={className}
            style={{ color: "var(--color-text)" }}>
            <Breadcrumb
                items={[
                    {
                        title: (
                            <Link to="/" style={{ color: "var(--color-text)" }}>
                                yasinyildiz.dev
                            </Link>
                        ),
                    },
                    {
                        title: (
                            <Link to="/blog" style={{ color: "var(--color-text)" }}>
                                Blog
                            </Link>
                        ),
                    },
                    {
                        title: <span style={{ color: "var(--color-text)" }}>{category}</span>,
                    },
                    {
                        title: <span style={{ color: "var(--color-text)" }}>{slug}</span>,
                    },
                ]}
            />

            <div
                style={{
                    position: 'relative',       // mutlak pozisyon için parent relative olmalı
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'end',
                }}
            >
                {isPinned && (
                    <Tooltip title={t("pinnedText")}>
                        <span
                            style={{
                                position: 'absolute',
                                top: '-5px',
                                fontSize: '20px',
                                zIndex: 10,
                            }}
                        >
                            📌
                        </span>
                    </Tooltip>
                )}
                <img
                    style={{
                        width: "100%",
                        aspectRatio: "2 / 1",
                        objectFit: "cover",
                        marginBottom: "10px",
                        marginTop: "10px",
                        boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
                        borderRadius: "5px",
                    }}
                    src={imgUrl}
                    alt={title}
                />
            </div>
            <h1>{title}</h1>
            <span style={{ display: "flex", flexDirection: "column", gap: "10px", marginTop: "10px" }}>
                <>
                    <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }} >
                        <p style={{ color: "#3f51b5" }}>{category}</p>
                        <div
                            style={{ display: 'flex', width: '5px', height: '5px', backgroundColor: 'black', borderRadius: '100px' }}
                        >
                        </div>
                        <p>{wordStats.readingTime} {t("readingTime")}</p>
                        <div
                            style={{ display: 'flex', width: '5px', height: '5px', backgroundColor: 'black', borderRadius: '100px' }}
                        >
                        </div>
                        < p > {wordStats.words} {t("words")}</p>
                    </div>
                    <div
                        className="article-dates-div"
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-evenly',
                            padding: '4px 8px',
                            borderRadius: '10px',
                            border: '2px solid var(--color-bg-secondary)',
                            alignItems: 'stretch',
                        }}
                    >
                        <Tooltip placement="top" title={t("createdDateTooltipText")}>
                            <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                                <i style={{ fontSize: '20px' }} className="fi fi-rr-calendar"></i>
                                <span>
                                    {t("createSpanText")}
                                    <p>{created.format("D MMMM YYYY")}</p>
                                </span>
                            </div>
                        </Tooltip>
                        <div
                            style={{
                                width: '2px',
                                backgroundColor: 'var(--color-bg-secondary)',
                                borderRadius: '100px',
                            }}
                        ></div>
                        <Tooltip placement="top" title={t("updatedDateTooltipText")}>
                            <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                                <i style={{ fontSize: '20px' }} className="fi fi-rr-calendar"></i>
                                <span>
                                    {t("updateSpanText")}
                                    <p>{updated.format("D MMMM YYYY")}</p>
                                </span>
                            </div>
                        </Tooltip>
                    </div>
                </>
            </span >
        </div >
    );
};